exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section.home-header{background-color:var(--header-bg-color);color:var(--header-text-color)}h1{font-size:40px}h1,h2{max-width:495px;font-family:var(--font);font-weight:700;font-style:normal;letter-spacing:normal;line-height:normal}h2{font-size:25px}.webshop-link{height:100%;background-color:var(--header-bg-color);color:var(--heading-color);font-size:22px;text-decoration:none!important;transition:all .3s ease;padding:10px}.webshop-link:hover{background-color:var(--main-color);color:#fff}", ""]);

// exports
